import { useTheme, Breakpoint } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

export const useIsBreakpointUp = (breakpoint: Breakpoint): boolean => {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.up(breakpoint), {
    noSsr: true
  });
};

export const useIsBreakpointDown = (breakpoint: Breakpoint): boolean => {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.down(breakpoint), {
    noSsr: true
  });
};
export const useIsBreakpointOnly = (breakpoint: Breakpoint): boolean => {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.only(breakpoint), {
    noSsr: true
  });
};

export const useBreakpoint = (): Breakpoint => {
  const theme = useTheme();
  let breakpoint: Breakpoint = 'xl';

  if (useMediaQuery(theme.breakpoints.only('xs'))) breakpoint = 'xs';
  if (useMediaQuery(theme.breakpoints.only('sm'))) breakpoint = 'sm';
  if (useMediaQuery(theme.breakpoints.only('md'))) breakpoint = 'md';
  if (useMediaQuery(theme.breakpoints.only('lg'))) breakpoint = 'lg';

  return breakpoint;
};
